import { FC } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import Link from 'components/ui/link';
import { RootState } from 'store';
import Logout from 'components/logout';
import { userProfileRegistry } from './registry';
import { ComponentRegistry } from 'runtime/registry/components/ComponentRegistry';

export const defaultUserProfileLayout = {
  main: ['Avatar', 'Name', 'Logout'],
};

export const UserProfile: FC = () => {
  const user = useSelector((state: RootState) => state.user);

  const configProps = ComponentRegistry.getConfig('UserProfile');
  const layout = ComponentRegistry.getResolvedLayout<{ main: string[] }>(
    'UserProfile',
    defaultUserProfileLayout
  );

  const renderSlot = (slot: string) => {
    const Component = userProfileRegistry[slot];

    if (!Component) return null;

    const props = configProps?.props?.[slot] ?? {};

    return <Component key={slot} {...props} name={user.name} user={user} />;
  };
  return (
    <>
      <Link
        url='/profile'
        className={classNames(
          'header__item header__item_bordered header__item_profile flex items-center',
          { header__item_rounded: !!user.avaUrl }
        )}>
        {layout.main.map((slot) => renderSlot(slot))}
      </Link>
      <Logout />
    </>
  );
};
